var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"system-check"},[_c('Header',{attrs:{"headerTitle":"Pre-Registration"}}),_c('div',{staticClass:"system-check-contents"},[_c('Stepper'),_c('Step')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }